import { render, staticRenderFns } from "./DocumentsIcon.vue?vue&type=template&id=041b8c54"
import script from "./DocumentsIcon.vue?vue&type=script&lang=ts"
export * from "./DocumentsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports